import { DataBaseComponent, DataBaseComponentState } from "components/DataBaseComponent";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import repository from "client/repository";
import * as React from "react";
import ReefMultiSelect from "shared/ReefMultiSelect";
import { ReefResource } from "client/resources/reefResource";
import InternalRedirect from "components/Navigation/InternalRedirect";
import {backgroundTasksRouteLinks} from "areas/backgroundTasks/backgroundTasksRouteLinks";
import { HostedInstanceBulkReconfigureDeactivatedResourcesRequest } from "client/resources/hostedInstanceBulkReconfigureDeactivatedResourcesRequest";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {
}

interface State extends DataBaseComponentState {
    reefs: Map<string, ReefResource>;
    request: HostedInstanceBulkReconfigureDeactivatedResourcesRequest;
    redirectTo?: string;
}

export default class BulkReconfigureDeactivatedInstanceResourcesDialog extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            reefs: new Map<string, ReefResource>(),
            request: {
                ReefIds: [],
                ReprovisionDuringWeekends: true
            },
        };
    }

    componentDidMount() {
        return this.doBusyTask(async () => {
            const reefs = repository.Reefs.map();

            this.setState({
                reefs: await reefs
            });
        });
    }

    render() {
        if (this.state.redirectTo) {
            return <InternalRedirect to={this.state.redirectTo}/>;
        }

        return <SaveDialogLayout title={`Bulk Reconfigure Deactivated Instance Resources`}
            saveButtonLabel={"Run task"}
            onSaveClick={() => this.bulkReconfigureDeactivatedInstanceResources()}
            errors={this.state.errors}
            busy={this.state.busy}>

            <ReefMultiSelect
                items={this.state.reefs ? Array.from(this.state.reefs.values()) : []}
                value={this.state.request.ReefIds}
                onChange={ReefIds => this.updateRequest({ReefIds})}
            />
            <p>
                Instance resources will be reconfigured only if they are on the selected Reefs. If no Reef has been selected, all Instances will be reconfigured.
            </p>
        </SaveDialogLayout>;
    }

    private updateRequest(update: Partial<HostedInstanceBulkReconfigureDeactivatedResourcesRequest>) {
        return this.setState(prevState => ({request: {...prevState.request, ...update}}));
    }

    private async bulkReconfigureDeactivatedInstanceResources(): Promise<boolean> {
        return await this.doBusyTask(async () => {
            const backgroundTask = await repository.HostedInstances.bulkReconfigureDeactivatedInstanceResources(this.state.request);
            this.setState({redirectTo: backgroundTasksRouteLinks.task(backgroundTask.Id).root})
        });
    }
}
